import { render } from "./App.vue?vue&type=template&id=2edb2eaa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2edb2eaa&lang=css"

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__